import React, { useState } from 'react';
import Modal from '../../Atoms/Modal/Modal';
import ModalChildrenContainer from '../../Atoms/Modal/ModalChildrenContainer';
import TextInput from '../../Atoms/Inputs/TextInput';
import Buttons from '../../Atoms/Buttons/Buttons';
import folderIcon from '../../../assets/Imagess/folderICon.svg';
import { Formik, Form } from 'formik';
import addCalendarValidationSchema from '../../../ValidationSchema/CalendarValidationSchema';
import { toast } from 'react-toastify';
import LoaderButton from '../Loader/LoaderButton';
import { useFetchAcademicYears } from '../../../Hooks/Settings';
import styles from './EventModal.module.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { useAddCalendar } from '../../../Hooks/Calendar';
import ColorInput from '../../Atoms/Inputs/ColorInput';
import calendarIconGrey from '../../../assets/Imagess/calendar-icon.svg';
import { useToast } from '../Custom/CustomToaster/Toast';
import DateInput from '../../Atoms/Inputs/DateInput';
import CustomSelect from '../../Atoms/forms/customSelect/CustomSelect';

const EventModal = ({
  handleOnClose,
  title,
  mode,
  refetchCalendar,
  itemToEdit,
  setItem,
  selectedIndex,
  selectedYear,
}) => {
  const [errorMessage, setErrorMessage] = useState('');
  const customizeToaster = useToast();
  const { mutate: addCalendar, isLoading: isAddingCalendar } = useAddCalendar();
  const { data: academicYears } = useFetchAcademicYears();

  // const calendarIcon = (
  //   <svg
  //     width='22'
  //     height='22'
  //     viewBox='0 0 22 22'
  //     fill='none'
  //     xmlns='http://www.w3.org/2000/svg'
  //   >
  //     <g id='Group 20956'>
  //       <path
  //         id='Vector'
  //         d='M5.43428 0C5.89173 0 6.26256 0.356629 6.26256 0.79655V2.40335C6.99725 2.38964 7.82078 2.38964 8.74737 2.38964H13.1648C14.0914 2.38964 14.9149 2.38964 15.6496 2.40335V0.79655C15.6496 0.356629 16.0204 0 16.4779 0C16.9353 0 17.3062 0.356629 17.3062 0.79655V2.47382C18.8957 2.59623 19.9393 2.89665 20.7059 3.63393C21.4726 4.37121 21.785 5.37475 21.9122 6.90341L21.9999 7.69996H1.01701H0V6.90341C0.12728 5.37475 0.439668 4.37121 1.20631 3.63393C1.97296 2.89665 3.01647 2.59623 4.60601 2.47382V0.79655C4.60601 0.356629 4.97684 0 5.43428 0Z'
  //         fill='#A9A7A7'
  //       />
  //       <path
  //         id='Vector_2'
  //         d='M22 14.0001V12.0001C22 11.161 21.9965 9.66526 21.9823 9H0.0110106C-0.00319018 9.66526 0.000406649 11.161 0.000406649 12.0001V14.0001C0.000406649 17.7712 0.000406628 19.6568 1.28911 20.8284C2.57782 22 4.65196 22 8.80026 22H13.2002C17.3485 22 19.4226 22 20.7114 20.8284C22 19.6568 22 17.7712 22 14.0001Z'
  //         fill='#A9A7A7'
  //       />
  //     </g>
  //   </svg>
  // );

  const initialValues = {
    calendarId: itemToEdit.calendarId || '00000000-0000-0000-0000-000000000000',
    calendarType: selectedIndex || 0,
    calendarText: itemToEdit.calendarText || '',
    academicYearId: selectedYear || '',
    colorCode: itemToEdit.colorCode || '',
    fromDate: itemToEdit.fromDate?.substring(0, 10) || '',
    endDate: itemToEdit.endDate?.substring(0, 10) || '',
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={addCalendarValidationSchema}
      onSubmit={(values) => {
        addCalendar(values, {
          onSuccess: () => {
            refetchCalendar();
            handleOnClose();
            customizeToaster.open(
              mode === 'add' ? 'تم إضافة الحدث' : 'تم تحديث الحدث'
            );
            setItem({});
          },
          onError: (error, data) => {
            console.error('حدث خطأ:', error?.response?.data?.message);
            toast.error('حدث خطأ ما');
            setErrorMessage(error?.response?.data?.message);
          },
        });
      }}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => {
        return (
          <Form>
            <Modal
              onClose={handleOnClose}
              title={
                mode === 'add' ? 'جديد' + ' ' + title : 'تعديل' + ' ' + title
              }
              width='35rem'
              closeWhite={false}
            >
              <ModalChildrenContainer>
                <input hidden value={values.calendarId} />
                <TextInput
                  label='أدخل اسم الحدث'
                  icon={folderIcon}
                  placeholder='أدخل اسم الحدث'
                  name='calendarText'
                  value={values.calendarText}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  errors={errors.calendarText}
                  touched={touched.calendarText}
                  containerStyle={{ padding: '0px' }}
                  left
                />
                {/* <CustomSelect
                  label='اختر السنة'
                  placeholder='اختر السنة'
                  name='academicYearId'
                  icon={calendarIconGrey}
                  style={{ width: '100%' }}
                  value={values.academicYearId}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  options={academicYears?.data?.map((option) => ({
                    value: option.acadamicYearId,
                    text: option.academicName,
                  }))}
                  errors={errors.academicYearId}
                  touched={touched.academicYearId}
                  right
                /> */}
                <ColorInput
                  label='اللون'
                  name='colorCode'
                  placeholder='اختر لوناً'
                  style={{ padding: '0px' }}
                  inputStyleProp={{ padding: '20px' }}
                  textInputStyle={{ paddingLeft: '10px', textAlign: 'end' }}
                  value={values.colorCode}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  errors={errors.colorCode}
                  touched={touched.colorCode}
                  right
                />
                <div className={styles['date-picker-container']}>
                  {' '}
                  <DateInput
                    label='تاريخ الانتهاء'
                    placeholder='اختر تاريخ الانتهاء'
                    showIcon
                    value={values.endDate}
                    name='endDate'
                    onChange={setFieldValue}
                    dateFormat='yyyy-MM-dd'
                    timeFormat='HH:mm'
                    timeInputLabel='الوقت:'
                    errors={errors.endDate}
                    touched={touched.endDate}
                    showTimeSelect
                    right
                  />
                  <DateInput
                    label='تاريخ البدء'
                    placeholder='اختر تاريخ البدء'
                    showIcon
                    value={values.fromDate}
                    name='fromDate'
                    onChange={setFieldValue}
                    dateFormat='yyyy-MM-dd'
                    errors={errors.fromDate}
                    touched={touched.fromDate}
                    right
                  />{' '}
                </div>
                {isAddingCalendar ? (
                  <LoaderButton />
                ) : (
                  <Buttons
                    text={mode === 'add' ? 'حفظ' : 'تحديث'}
                    handleOnClick={handleSubmit}
                    rounded={true}
                    style={{
                      marginTop: '14px',
                      padding: '16px 19px',
                      borderRadius: '50px',
                      fontFamily: 'BukraBold',
                      fontSize: '20px',
                    }}
                  />
                )}
              </ModalChildrenContainer>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default EventModal;
